import { currencySymbols } from "@/constants/currencySymbols";

export const getCurrencySymbol = (currency?: string): string => {
  return currency ? currencySymbols[currency] || currency : "";
};
